import React, { useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardHeader,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
  useTheme,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import axios from 'axios';
import { debounceTime, url } from 'src/Helpers/utils/Constant';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import { IIdCard } from 'src/Types/module/IdCard/IdCard';
import { getStatusLabel } from 'src/Utils/Combined';
import { debounce } from 'lodash';
import { Box } from '@mui/system';

const IdCard = () => {
  const [idCard, setIdCard] = useState<IIdCard[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterItem, serFilterItem] = useState<any>({
    applicant_name: '',
    status: 'pending',
  });
  const theme = useTheme();

  useEffect(() => {
    setLoading(true);
    try {
      (async () => {
        const { data } = await axios.get(
          `${url}/api/member/id-card/application?applicant_name=${filterItem.applicant_name}&status=${filterItem.status}`,
        );

        if (data.success) {
          setIdCard(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })();
    } catch (error) {
      setLoading(false);
    }
  }, [filterItem.applicant_name, filterItem.status]);

  const handelChangeInput = debounce((value) => {
    serFilterItem({
      ...filterItem,
      applicant_name: value,
    });
  }, debounceTime);

  const statusOptions = [
    {
      id: 'completed',
      name: 'Completed',
    },
    {
      id: 'pending',
      name: 'Pending',
    },
    {
      id: 'rejected',
      name: 'Rejected',
    },
  ];

  return (
    <Container sx={{ mt: 1, pb: 3 }} maxWidth='xl'>
      <Card>
        <CardHeader
          action={
            <Box display='flex' alignItems='center' gap={2}>
              <TextField
                // style={{ height: "10px" }}0
                id='outlined-basic'
                label='Search by agency name '
                variant='outlined'
                size='small'
                onChange={
                  (e: React.ChangeEvent<HTMLInputElement>) =>
                    handelChangeInput(e.target.value)

                  // setSearchCompanyVal(e.target.value)
                }
              />
              <FormControl sx={{ width: '150px' }} variant='outlined'>
                <InputLabel>Status</InputLabel>
                <Select
                  size='small'
                  value={filterItem.status}
                  onChange={(e) =>
                    serFilterItem({
                      ...filterItem,
                      status: e.target.value,
                    })
                  }
                  label='Status'
                  autoWidth
                >
                  {statusOptions.map((statusOption) => (
                    <MenuItem key={statusOption.id} value={statusOption.id}>
                      {statusOption.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          }
          title={
            <Typography sx={{ fontWeight: 700, lineHeight: 1.34 }}>
              ID Card Applications
            </Typography>
          }
        />
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Sl.</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Agency Name</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Applicant Name</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Created At</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableLoader />
              ) : (
                <>
                  {idCard?.length ? (
                    <>
                      {idCard.map((sIdCard, index) => {
                        return (
                          <TableRow key={sIdCard.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              <Link
                                to={`/member-list/${sIdCard.user_member_id}`}
                              >
                                {sIdCard.user_member_company_name}
                              </Link>
                            </TableCell>
                            <TableCell>{sIdCard.applicant_name}</TableCell>
                            <TableCell>
                              {moment(sIdCard.created_at).format('MMM Do YY')}
                            </TableCell>
                            <TableCell>
                              {getStatusLabel(sIdCard.status)}
                            </TableCell>
                            <TableCell>
                              <Link
                                to={`/update-applications/id-card/${sIdCard.id}`}
                              >
                                <Tooltip title='view' arrow>
                                  <IconButton
                                    sx={{
                                      '&:hover': {
                                        background:
                                          theme.colors.primary.lighter,
                                      },
                                      color: theme.palette.primary.main,
                                    }}
                                    color='inherit'
                                    size='small'
                                  >
                                    <VisibilityIcon fontSize='small' />
                                  </IconButton>
                                </Tooltip>
                              </Link>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                  ) : (
                    <TableNotFound />
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Container>
  );
};

export default IdCard;
